import { ConfigStore } from "../../store/modules/config";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import { appConfig } from "../../config/index";
import IAlertService from "../../services/alert/IAlertService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import i18n from "@/i18n";

/**Базовый layout */
export class BaseLayoutVue extends Vue {
  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get appVersion(): string {
    return appConfig.version ?? "";
  }

  hideVersionDialog(): void {
    const routeQuery: Array<string> = Object.keys(this.$route.query);
    if (routeQuery.length === 1)
      this.$router.replace({'query': null});
    else {
      let path: any = this.$route.fullPath;
      this.$router.replace({path: path.replace('showClientVersion=true', 'showClientVersion=false')})
    }
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**Инициализация стартовых данных приложения */
  async init(): Promise<void> {
    if (this.$route.query['showClientVersion'] === 'true')
      this.alertService.info(`${i18n.t("common.clientVersion")} ${this.appVersion}`, false, () => this.hideVersionDialog())
    await this.configStore.fetchApiState();
    await this.configStore.fetchPasswordRequirements();
    await this.configStore.fetchProducts();
    await this.configStore.fetchPhoneFormatDir();
  }
}
